import { IListOptionsFilter } from "./base";

export interface IOrderTaskPostFilter extends IListOptionsFilter {
  projectId?: number;
  responsibleId?: number;
  resourceId?: number;
  costTypeId?: number;
  orderTaskStatusId?: number;
  limitToProject?: boolean;
  limitToResponsible?: boolean;
  limitToResource?: boolean;
  limitToCostType?: boolean;
  dateFrom: number;
  dateTo: number;
  orderId?: number;
  orderTaskId?: number;
  isApproved?: boolean;
  voucherId?: number;
  fiscalDateFrom?: number;
  fiscalDateTo?: number;
}
